module.exports = __webpack_public_path__ + "img/MGH-Yokohama-2-2440x1172.99a11921.jpg";